import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ReactNode, useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import AddEditBeneficiaryModal from '../../../components/AddNewBeneficiary/AddEditBeneficiaryModal';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import FamilyMemberCard from '../../../components/FamilyMemberCard';
import useModal from '../../../hooks/useModal';
import {
  FamilyMembersProvider,
  FamilyMembersStore,
} from '../../../providers/familyMembers';

const SectionHeadlineWrapper: React.FC<{
  title: string;
  icon: IconDefinition;
  rightComponent?: ReactNode;
}> = ({ title, icon, rightComponent }) => {
  return (
    <section className={'w-100 d-flex justify-content-between mt-7'}>
      <div className={'d-flex align-items-center'}>
        <CircledIcon variant={'icon-emphasized'} icon={icon} />
        <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>{title}</h4>
      </div>
      <div className={'d-none d-lg-block'}>{rightComponent}</div>
    </section>
  );
};

const FamilyMembersWrapper = () => {
  return (
    <FamilyMembersProvider>
      <FamilyMembersContent />
    </FamilyMembersProvider>
  );
};

const FamilyMembersContent = () => {
  const [
    showAddFamilyMemberModal,
    handleAddFamilyMemberShow,
    handleAddFamilyMemberClose,
  ] = useModal();

  const { addFamilyMember, familyMembers } = useContext(FamilyMembersStore);

  const handleAddFamilyMemberSubmit = (data: any) => {
    addFamilyMember(data);
  };

  return (
    <>
      <SectionHeadlineWrapper
        title={'Family Members'}
        icon={light('family')}
        rightComponent={
          <Row className={'d-none d-lg-block'}>
            <Col>
              {/* <Button
                size={'sm'}
                rightIcon={light('circle-plus')}
                onMouseDown={handleAddFamilyMemberShow}
              >
                Add new
              </Button> */}
            </Col>
          </Row>
        }
      />
      <div className={'mt-10 d-flex flex-column gap-7'}>
        {familyMembers.map((familyMember: any, index: number) => (
          <FamilyMemberCard
            key={index}
            name={familyMember.name}
            covers={familyMember.covers}
            image={familyMember.image}
            isVerified={familyMember.isVerified}
            ssn={familyMember.ssn}
            relationship={familyMember.relationship}
            dateOfBirth={familyMember.dateOfBirth}
            isActionRequired={familyMember.isActionRequired}
          />
        ))}
      </div>
      <Row className={'d-lg-none'}>
        <Col className={'w-100 mt-7 d-flex flex-column'}>
          {/* <Button
            variant={'primary-outline'}
            rightIcon={light('circle-plus')}
            onMouseDown={handleAddFamilyMemberShow}
          >
            Add new
          </Button> */}
        </Col>
      </Row>
      <AddEditBeneficiaryModal
        title="Add New Family Member"
        isForFamilyMember={true}
        showModal={showAddFamilyMemberModal}
        handleClose={handleAddFamilyMemberClose}
        handleSubmit={handleAddFamilyMemberSubmit}
      />
    </>
  );
};

export default FamilyMembersWrapper;
